// ============================================================
// Uygulama sabitleri
// ============================================================

// ---------- Firebase yapılandırması ----------
// Değerler .env dosyasından okunur (bkz. .env.example). Yapılandırma
// eksikse uygulama yerel depoya düşer; Firebase paketi hiç yüklenmez.
const env = (typeof import.meta !== "undefined" && import.meta.env) || {};

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
};

export const firebaseHazir = Boolean(firebaseConfig.projectId && firebaseConfig.apiKey);

// ---------- Bugün ----------
//
// Tüm tarih hesapları bu tek noktadan okur.
//
// DEMO günü sabit ve öyle kalmalı: tohum verinin tamamı 5 Ağustos
// 2026'ya göre kurgulanmış — fatura dönemleri, yoklama geçmişi,
// süresi dolan belgeler. Tarihi oynatmak demoyu anlamsızlaştırır.
//
// GERÇEK modda cihazın günü. Bu satır bir süre yazılmamıştı ve
// uygulama gerçek moda geçtiği hâlde tarih 2026-08-05'te çakılı
// kaldı: canlı kreşin yoklaması bir ay öncesine yazılıyordu, imza
// klasörü ve fatura dönemi de öyle. Sessiz ve geriye dönük
// düzeltilmesi zor bir bozulma.
const DEMO_GUNU = "2026-08-05";

// sv-SE yerel ayarı YYYY-MM-DD veriyor ve YEREL saati kullanıyor.
// toISOString() UTC'ye çevirir; KKTC UTC+3 olduğu için gece
// yarısından sonraki üç saatte bir önceki günü yazardı.
export const bugunuHesapla = () =>
  new Date().toLocaleDateString("sv-SE");

export const BUGUN = firebaseHazir ? bugunuHesapla() : DEMO_GUNU;
export const DONEM = BUGUN.slice(0, 7);

// Fotoğraf işleme
export const PHOTO_KEY = "minikpanel.photos";
// MinikPanel öncesi ad. Tarayıcıda eski anahtarla duran fotoğraflar
// ilk okumada yeni anahtara taşınır; bir sürüm sonra silinebilir.
export const ESKI_PHOTO_KEY = "minikampus.photos";
export const PHOTO_SIZE = 256;
export const PHOTO_MAX_BYTES = 8 * 1024 * 1024;

